import { DotThemeProvider } from '@dot/design-system';
import { Suspense } from 'react';
import { default as styled } from 'styled-components';

import { InfoModal } from '../components/InfoModal/InfoModal';
import { ErrorBoundary } from '../components/error-boundary';
import { AppProvider } from '../providers/app-provider';

import { AppContent } from './app-content';

import { Loader as LoaderAtom } from '@/atoms/Loader/Loader';
import { Steps } from '@/steps';
import { GlobalStyle } from '@/styles/GlobalStyles';
import { theme } from '@/styles/theme';

import '../utils/i18n';
import '../utils/faro';

export const Loader = styled(LoaderAtom)`
  margin-left: auto;
  margin-right: auto;
  margin-top: 100px;
`;

export const App = () => {
  return (
    <Suspense fallback={<Loader />}>
      <AppProvider>
        <DotThemeProvider theme={theme}>
          <GlobalStyle />
          <ErrorBoundary>
            <AppContent>
              <Steps />
              <InfoModal />
            </AppContent>
          </ErrorBoundary>
        </DotThemeProvider>
      </AppProvider>
    </Suspense>
  );
};
